<template>
    <rkm-overlay>
        <rkm-layout-body title="Lista de paciente">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/imunizacao/registro-vacinacao/List'

export default {
    components: { List },
}
</script>